// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import {apiSlice} from './apiSlice';

export const codeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getICD10Codes: builder.query({
      query: () => 'icd_10_code/',
    }),
    getCPTCodes: builder.query({
      query: () => 'cpt_code/',
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetICD10CodesQuery,
  useGetCPTCodesQuery,
} = codeApi;
